module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/5x2-flatpack-2eb13b75f57ee93d6de16cd06e5706eb.png";